import React, {useState, useEffect} from 'react'
import Loading from '../../Commons/Loading/Loading';
import FooterFormulario from '../../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../DivisionesDetalles.scss'
import DivisionBanner from '../../DivisionContainer/DivisionBanner/DivisionBanner';
import { Modal } from 'react-bootstrap'


const CintaCalefactora = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };
    
    const handleShow = (paramUrl, paramDesc) => {
        
        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)
        
        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(()=> {
        setTimeout(()=>{
            setLoading(false)
        }, 1000)
    })

    if(loading) {return <Loading />}

    return (

        <section className='container-fluid p-0 containerBlock' > 


            <Modal
              show={show}
              size='lg'
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Cintas calefactoras.</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
              </Modal.Body>
            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-aislaciones-termicas.jpg" 
                    alt="Reparacion de Tanques." 
                    loading='lazy'
                    className='divisionItem__container--img'    
                />

                <div className='divisionItem__container--textos' >
                    <h3 className='divisionItem__container--header'>DIVISION</h3>
                    <h1 className='divisionItem__container--title'>AILSACIONES TERMICAS</h1>
                    
                </div>

            </div>

            <div className='container-fluid divisionItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/aislaciones-termicas/'}>
                    <small> 
                        <i className="fas fa-angle-double-left" style={{'paddingBottom':'15px', 'paddingRight': '10px'}} ></i> 
                        Volver a Division</small>
                    </Link>

                    <div className='row'>
                        <div className='col-md-6'> 
                            
                            <img 
                                src="../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-01.jpg" 
                                alt="Tanque de 50.000m3. con la obra terminada."
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            /> 

                        </div>

                        <div className='col-md-6 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Traceado eléctrico</h1>
                            <p  className='divisionItem__detail--text' > 
                                Hay casos que el traceado térmico puede ser imprescindible para tuberías de largo recorrido (kilómetros) o pocos metros y tener diversos objetivos:<br/><br/>
                                Impedir que la temperatura del fluido no supere un nivel critico bajo el que el fluido puede solidificarse o empezar a cristalizar.<br/><br/>
                                Evitar la formación de hielo o hidratos en las tuberías durante el invierno, coincidiendo con una parada del proceso.<br/><br/>
                                En un sistema de traceado eléctrico, se instala cable eléctrico en contacto con la tubería a calentar. Las tuberías pueden ser aisladas junto con su traceado eléctrico.<br/><br/>
                                Cada sistema se evalúa por cálculo la distribución de cada elemento para alcanzar el gradiente de temperatura que requiere el proceso. 
                                <br/>
                            </p>
                        </div>

                    </div>

                    <div className='gallery__cont'>
                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-04.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-04.jpg' alt='Anillo' loading='lazy' />
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-02.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-02.jpg' alt='Anillo' loading='lazy' /> 
                        </div>

                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-03.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-03.jpg' alt='Anillo' loading='lazy' />
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-01.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-01.jpg' alt='Anillo' loading='lazy'/>
                        </div>

                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-05.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-05.jpg' alt='Anillo' loading='lazy' />
                            <img    onClick={ () => handleShow('../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-06.jpg', 'Anillo.') } src='../images/divisiones/aislaciones-termicas/cinta-calefactora/cinta-calefactora-06.jpg' alt='Anillo' loading='lazy' />
                        </div>   
                    </div>
                </div>
            </div>
            
            <FooterFormulario className='mt-5' />

        </section>
    )
}

export default CintaCalefactora